export default {
	'items_per_page': 'Int',
	'page': 'Int',
}
